import styled from 'styled-components';
import { Button, lighten } from '@mui/material';

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  border-radius: 6;
  background: ${({theme}) => theme.palette.colors.white};
  border: 1px ${({theme}) => theme.palette.colors.gray200} solid;
`;

export const SFilterBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 10px;
`;

export const SFilterHeader = styled.div`
  display: flex;
  width: 100%;
  background-color: ${({theme}) => lighten(theme.palette.colors.blue100, 0.95)};
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
`;

export const SClearFilterButton = styled(Button)`
  && {
    :hover {
      background-color: inherit;
    }
  }
`;
